module.exports = __webpack_public_path__ + "img/lock.f78152cf.jpg";